// extracted by mini-css-extract-plugin
module.exports = {"title":"bundleTile_title__ry_rc","add":"bundleTile_add__Ol8NY"};